rdefine('app/Products',['backbone',
    'text!products/form.html',
    'app/products/collections/Variants',
    'app/products/components/ProductForm',
    'app/products/components/TabChoiceVariant',
    'app/products/components/CategoryItem',
    'app/products/collections/Categories',
    'app/products/collections/Properties'
    ],
    function(Backbone,template,Variants,ProductForm,
             TabChoiceVariant,CategoryItem,Categories,
             Properties) {
    return Backbone.Ribs.View.extend({
        variants:null,
        bindings:{
            '.variants': {
                /*toggleByClass:{
                    data:'model.variants',
                    processor:function(item) {
                        return item > 1;
                    }
                },*/
                collection:{
                    col:'variants',
                    view:TabChoiceVariant
                }
            },
            '.variant-tabs':{
                collection:{
                    col:'variants',
                    view:ProductForm,
                    data:{
                        parent:null
                    }
                },
                toggleByClass:{
                    data:'state.canadd'
                }
            },
            '.category-show':{
                collection:{
                    col:'categories',
                    view:CategoryItem
                }
            },
            '.not-show': {
                toggleByClass:{
                    processor:function(s) {
                        return !s;
                    },
                    data:'state.canadd'
                }
            },
            'el':{
                classes:{
                    loading:{
                        data:'model.loading'
                    }
                }
            }
        },
        events:{
            "click .add-variant":"addVariant"
        },
        state:null,
        properties:null,
        back:null,
        initialize:function(options) {
            this.back = options.back;
            this.model = new Backbone.Ribs.Model({variants:0,dirty:false,loading:false});
            this.state = new Backbone.Ribs.Model({canadd:false});
            this.bindings['.variant-tabs'].collection.data={languages:options.languages, parent:this, properties:null};
            this.variants = new Variants();
            if(options.cform) {
                _.map(options.cform.variants,function(variant,i){
                    this.variants.push({active:!i,cform:variant});
                }.bind(this));
            }else{
                this.variants.push({active:true,cform:{lang:{}}});
            }
            this.model.set("variants",this.variants.length);
            this.variants.on("add reset remvove",function(){
                this.model.set("variants",this.variants.length);
            }.bind(this));
            this.categories = new Categories([],{category_id:options.force_category?options.force_category:this.model.get("category_id")});
            this.categories.on("vischange",function(canadd,cid){
                this.state.set("canadd",canadd);
                this.properties.loadProperties(cid);
                this.model.set("category_id",cid);
                this.model.set("dirty",true);
            }.bind(this));
            this.properties = new Properties();
            this.bindings['.variant-tabs'].collection.data.parent = this;
            this.bindings['.variant-tabs'].collection.data.properties = this.properties;
            this.$el.html(Template7.compile(template)({ currentlang:window.currentlang }));

        },
        addVariant: function() {
            this.variants.add({active:false,cform:{lang:{}}});
            this.variants.setActiveLast();
        },
        cancel:function() {
            $("#dismisModal").modal('show');
            $("#dismisModal").find(".btn-danger").attr("href",this.back);
            return false;
        },
        save:function() {
            var model = {
                variants:_.map(this.variants.models,function(model){
                        return model.attributes.cform;
                    }),
                category_id:this.model.get("category_id")
            };
            this.model.set("loading",true);
            var fd = new FormData(this.$el.find("form")[0]);
            fd.append('json',JSON.stringify(model));
            fd.append('_token',$('meta[name="csrf-token"]').attr('content'));
            fd.append('_method','POST');
            //find images field


            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: window.createurl,
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function ( data ) {
                    this.trueOrFalse(data);
                }.bind(this)
            });
            return false;
        },
        trueOrFalse:function(response) {
            if(response.success) {
                window.location = response.successurl;
                SuccessMessage(response.message);
            }else{
                this.model.set("loading", false);
            }
        }
    });
});